module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"titles":{"sorry":"Sorry...","lost_connection":"You have lost connection to our servers...","cta":"We recommend reloading the Diamond Duels App to reconnect"}}}')
  delete Component.options._Ctor
}
